import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import "./App.css";

import Home from './pages/Home';
import Logo from './pages/Logo';
import About from './pages/About';
import Services from './pages/Services';
import ServUX from './pages/ServUX';
import ServDev from './pages/ServDev';
import ServStrat from './pages/ServStrat';
import ServTrain from './pages/ServTrain';
import Contact from './pages/Contact';
import Footer from './components/Footer';

function App() {

  // render the fetched Contentful data
  return (
    <div className="App">
      <BrowserRouter>
        <div className="header parentDiv">
          
          </div>
        <div className="content parentDiv">
          <Routes>
            <Route exact path='/' element={<Logo />} />
            <Route exact path='/home' element={<Home />} />
            <Route exact path='/about' element={<About />} />
            <Route exact path='/services' element={<Services />} />
            <Route exact path='/services/serv-ux' element={<ServUX />} />
            <Route exact path='/services/serv-dev' element={<ServDev />} />
            <Route exact path='/services/serv-train' element={<ServTrain />} />
            <Route exact path='/services/serv-strat' element={<ServStrat />} />
            <Route exact path='/contact' element={<Contact />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>

  );
}

export default App;
